<template>
  <div id="app" :data-hash="version">
    <Loading ref="loading"></Loading>

    <transition name="page" mode="out-in">
      <component :is="layout" v-if="layout"></component>
    </transition>
  </div>
</template>

<style scoped>
@font-face {
  font-family: "Lato";
  src: url("/fonts/lato-regular-webfont.woff2") format("woff2"),
    url("/fonts/lato-regular-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
.application {
  font-family: "Lato", sans-serif !important;
}
.headline,
.title,
.subheading {
  font-family: "Lato", sans-serif !important;
}
.v-toolbar__side-icon .v-btn__content .v-icon.theme--light {
  color: #103a84;
  font-size: 32px;
}
.v-toolbar__side-icon .v-btn__content .v-icon.theme--dark {
  color: #ffffff;
  font-size: 32px;
}
/* Openorders dropdown */
>>> .theme--light .v-menu__content.openorders-dropdown {
  border-radius: 10px !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 400px;
  height: 300px;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
}
>>> .theme--light .v-menu__content.openorders-dropdown:-webkit-scrollbar {
  width: 0;
  height: 0;
}
>>> .theme--dark .v-menu__content.openorders-dropdown {
  border-radius: 10px !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 400px;
  height: 300px;
  box-shadow: none !important;
  background: #303030;
}
>>> .theme--dark .v-menu__content.openorders-dropdown:-webkit-scrollbar {
  width: 0;
  height: 0;
}
/**************** NEW TOGGLE BUTTON ************************/
>>> .v-input--switch .v-input--selection-controls__input {
  width: 46px;
}
>>> .v-input--switch__track {
  border-radius: 23px;
  height: 26px;
  left: 2px;
  position: absolute;
  right: 2px;
  top: 0;
  opacity: 1;
}
>>> .v-input--switch__thumb {
  border-radius: 50%;
  top: calc(50% - 10px);
  height: 22px;
  position: relative;
  width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06);
  margin-left: 4px;
}
>>> .theme--light.v-input--switch__thumb {
  color: #ffffff;
}
>>> .theme--light.v-input--switch__track {
  color: #e1e5eb;
}
>>> .v-input--switch__thumb.accent--text {
  color: #ffffff !important;
  caret-color: #ffffff !important;
}
>>> .theme--light.v-input--switch__track.accent--text {
  color: #395fa9 !important;
  caret-color: #395fa9 !important;
}

>>> .theme--dark.v-input--switch__track {
  color: #959596;
}
>>> .theme--dark.v-input--switch__track.accent--text {
  color: #639bfb !important;
  caret-color: #639bfb !important;
}
>>> .theme--dark.v-input--switch__thumb {
  color: #ffffff;
}
>>> .v-dialog.v-dialog--active {
  border-radius: 15px !important;
}
/********************* NEW TOGGLE BUTTON END *********************************/

/********************* NOTIFICATIONS DIALOG *********************************/
>>> .notifications-dialog {
  position: absolute;
  right: 0px;
  top: 0px;
}
>>> .theme--light .notifications-dialog {
  background: #ffffff;
  margin-top: 60px;
  height: 398px;
}
>>> .theme--dark .notifications-dialog {
  background: #424242;
  margin-top: 60px;
  height: 398px;
}
/********************* NOTIFICATIONS DIALOG END *********************************/
</style>
<script>
import Loading from "./Loading";
import {mapGetters} from "vuex";

// Load layout components dynamically.
const requireContext = require.context("../layouts", false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component;
    return components;
  }, {});

Object.filter = (obj, predicate) =>
  Object.fromEntries(Object.entries(obj).filter(predicate));

export default {
  el: "#app",

  components: {
    Loading
  },

  metaInfo() {
    const { appName } = window.config;

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    };
  },

  data: () => ({
    layout: null,
    defaultLayout: "default",
    insightsLayout: "insights"
  }),
  computed: {
    ...mapGetters({
      version: "settings/version"
    })
  },
  mounted() {
    this.$loading = this.$refs.loading;
  },
  created: function() {
    if (!this.$store.getters["settings/version"]) {
      this.$store.dispatch("settings/fetchVersion");
    }
  },
  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      const host = window.location.host;
      const parts = host.split(".");
      if (parts.includes("insights") || parts.includes("insights-alpha")) {
        this.layout = layouts[this.insightsLayout];
      } else {
        this.layout = layouts[layout];
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/App.vue